import type { ProductItem } from '@tilelist/domain/composition/TileListitem.ts';

const MAX_TILES = 20;
const MIN_ORGANIC = 5;
const SPONSORED_POSITIONS = new Set([2, 3, 5, 7, 9, 11, 13, 15, 17, 19]);

function isUsable(item: ProductItem): boolean {
    return item.variations.length > 0 && !!item.currentVariationId;
}

function composeTiles(organic: ProductItem[], sponsored: ProductItem[]): ProductItem[] {
    const tiles: ProductItem[] = [];
    let nextOrganic = 0;
    let nextSponsored = 0;
    for (let position = 1; position <= MAX_TILES; position++) {
        if (SPONSORED_POSITIONS.has(position) && nextSponsored < sponsored.length) {
            tiles.push(sponsored[nextSponsored++]);
        } else if (nextOrganic < organic.length) {
            tiles.push(organic[nextOrganic++]);
        } else {
            break;
        }
    }
    while (tiles.at(-1)?.product.productType === 'sponsored') tiles.pop();
    return tiles;
}

/**
 *
 *
 */
export function composeSponsoredBlackFridaySlider({
    organic,
    sponsored,
}: {
    organic: ProductItem[];
    sponsored: ProductItem[];
}): ProductItem[] | null {
    const usableOrganic = organic.filter(isUsable);
    const usableSponsored = sponsored.filter(isUsable);

    for (let count = Math.min(usableSponsored.length, SPONSORED_POSITIONS.size); count >= 0; count--) {
        const candidates = usableSponsored.slice(0, count);
        const displayed = new Set(candidates.map((item) => item.currentVariationId));
        const queue = usableOrganic.filter((item) => !displayed.has(item.currentVariationId ?? ''));
        const tiles = composeTiles(queue, candidates);
        if (tiles.filter((tile) => tile.product.productType === 'sponsored').length !== count) continue;

        /*                                                                                            */
        if (queue.length < MIN_ORGANIC) return null;

        return tiles.map((tile, index) => ({
            ...tile,
            localListPosition: index + 1,
            actualListPosition: index + 1,
        }));
    }
    return null;
}
